<template>
  <div id="app">
    <div class="navbar-wrapper">
      <navbar v-if="this.$store.state.auth.user"/>
    </div>
    <BugBanner v-if="hasSISAccess"/>
    <sitewideSideMenu :disabled="!this.$store.state.auth.user">
<!--      todo: note the padding bottom is for he bug banner-->
      <div style="padding-bottom: 24px;">
        <router-view :key="$route.fullPath"/>
      </div>
    </sitewideSideMenu>

    <searchbar v-if="$store.state.search.displaySearchBar"/>

    <div v-if="$store.state.auth.user && canEnableMentorChat()">
      <MentorChat></MentorChat>
    </div>
    <Loader :show="$store.state.loader.running" :text="$store.state.loader.text"></Loader>
  </div>
</template>

<script>
import Navbar from "./components/layout/Navbar.vue";
import Loader from "./components/Loader.vue";
import sitewideSideMenu from "./components/sitewideSideMenu.vue";
import MentorChat from "./components/global/MentorChat";
import SearchSideBar from "./components/layout/SearchSideBar";
import mixpanel from "mixpanel-browser";
import {UserClient} from "@/clients/UserClient";
import BugBanner from "@/components/global/AlertBanner.vue";
import {mapGetters, mapState} from "vuex";
import User from "@/models/lms/User";
import VueCookies from 'vue-cookies';

export default {
  name: "App",
  components: {
    Navbar,
    Loader,
    MentorChat,
    searchbar: SearchSideBar,
    sitewideSideMenu,
    BugBanner
  },
  computed: {
    ...mapState("auth", ["user"]),
    ...mapState("cometChat", ["chatEnabled"]),
    hasSISAccess() {
      return VueCookies.get('sisAccessToken')
    },
    isSidebarVisibible: function () {
      if (
          this.$store.state.auth.user &&
          this.$route.name != "courses" &&
          this.$route.name != "canvas.index" &&
          this.$route.name != "canvas.view" &&
          this.$route.name != "login"
      ) {
        return true;
      } else {
        return false;
      }
    },
    allowChatBubble() {
      return this.$route?.meta?.allowChatBubble !== false;
    },
  },
  watch: {
    $route(to, from) {
      this.$store.state.app.prevRoute = from
      this.trackWithMixpanel(to, from)
    },
    user(value) {
      if(!value?.id) {
        return
      }

      if (this.allowChatBubble && this.chatEnabled) {
        this.delayedLaunch();
      }
    },
  },
  methods: {
    delayedLaunch(chatLaunchAttempt = 0) {
      if (!this.allowChatBubble) {
        return;
      }
      if(chatLaunchAttempt > 10) {
        return
      }
      if (this.$store.getters["tenant/isCentral"]) {
        return;
      }
      if (
          !this.user?.first_name.length ||
          !this.user?.uuid ||
          typeof this.$store.state.cometChat.chat_app_id !== "string"
      ) {
        setTimeout(() => {
          this.delayedLaunch(chatLaunchAttempt + 1);
        }, 500);
        return;
      }
      this.launch();
    },
    async launch() {
      try {
        // eslint-disable-next-line no-undef
        await CometChatWidget.init({
          appID: this.$store.state.cometChat.chat_app_id,
          appRegion: this.$store.state.cometChat.chat_app_region,
          authKey: this.$store.state.cometChat.chat_app_auth_key,
        });
      } catch (err) {
        return;
      }

      // eslint-disable-next-line no-undef
      const user = new CometChatWidget.CometChat.User(this.user.uuid);
      user.setName(this.user.first_name + " " + this.user.last_name);
      user.setAvatar(this.user.avatar);
      if (this.$store.state.auth.type === "guardian") {
        user.setLink(`https://${process.env.VUE_APP_BASE_URL}/guardians/edit/${this.user.id}`);
      } else {
        user.setLink(`https://${process.env.VUE_APP_BASE_URL}/staff/edit/${this.user.id}`);
      }
      // eslint-disable-next-line no-undef
      await CometChatWidget.createOrUpdateUser(user);
      // eslint-disable-next-line no-undef
      CometChatWidget.login({
        uid: this.user.uuid,
      }).then(() => {
        // eslint-disable-next-line no-undef
        CometChatWidget.launch({
          widgetID: this.$store.state.cometChat.chat_app_widget_id,
          docked: "true",
          alignment: "right", //left or right
          roundedCorners: "true",
          height: "450px",
          width: "800px",
        }).then(() => {
          // eslint-disable-next-line no-undef
          CometChatWidget.on("openChat", () => {
            window.addEventListener("keydown", e => {
              if (e.key === "Escape") {
                // eslint-disable-next-line no-undef
                CometChatWidget.openOrCloseChat(false);
              }
            });
          });
          // eslint-disable-next-line no-undef
          CometChatWidget.on("closeChat", () => {
            window.removeEventListener("keydown", e => {
              if (e.key === "Escape") {
                // eslint-disable-next-line no-undef
                CometChatWidget.openOrCloseChat(false);
              }
            });
          });
        });
      });
    },
    trackWithMixpanel(to, from) {

      let from_suffix = "";
      if (from.query["tab"] !== undefined) {
        from_suffix = "?tab=" + from.query["tab"];
      }
      let to_suffix = "";
      if (to.query["tab"] !== undefined) {
        to_suffix = "?tab=" + to.query["tab"];
      }

      if (to.name + to_suffix !== from.name + from_suffix) {
        const lmsToken = this.$cookies.get('lmsAccessToken') || localStorage.getItem('lmsAccessToken') || null;
        if (from.name == "auth.login" && lmsToken) {

          User.GetUser().then(({response: {data}}) => {
            mixpanel.identify(data.data.uuid);
            const mixpanelSet = {
              "First Name": data.data.attributes.first_name,
              "Last Name": data.data.attributes.last_name,
              $email: data.data.attributes.email,
              $name: data.data.attributes.first_name + " " + data.data.attributes.last_name,
              Roles: data.data.attributes.roles.map((role) => role.attributes.name),
              Id: data.data.id,
              "Tenant Id": data.data.attributes.tenant_id,
            };
            mixpanel.people.set(mixpanelSet);


            // TODO: Perhaps in the future we can implement the login track and perhaps identify more similar to how it's done on SIS. In the interim we do it like this. I couldn't figure out how the SIS one works so perfectly. The problem was the login wasn't being attributed to the same user as the identify and actions thereafter.
            this.track("Login", {
              succeeded_at: new Date(),
            });


            this.trackPageView("pageView." + to.name + to_suffix, {})
          });
        } else {
          this.trackPageView("pageView." + to.name + to_suffix, {})
        }
      }
    },
    trackPageView(name, params) {
      // this.track(name, params);
    },
    canEnableMentorChat() {
      return false; //TODO NW: reenable chat here when working
      // if (
      //     this.$route.name == "chat" ||
      //     this.$route.name == "chat.channel" ||
      //     this.$route.name == "canvas.index" ||
      //     this.$route.name == "canvas.view"
      // ) {
      //     return false;
      // }
      // return true;
    },
  },
  mounted() {
    window.addEventListener('resize', () => {
      this.$store.dispatch('size/setHeight', window.innerHeight)
      this.$store.dispatch('size/setWidth', window.innerWidth)
    })
    this.$store.state.cometChat.chatScriptLoaded = true;
    if (this.allowChatBubble && this.chatEnabled) {
      this.delayedLaunch();
    }
  },
  beforeDestroy() {
    window.removeEventListener('resize', () => {
      this.$store.dispatch('size/setHeight', window.innerHeight)
      this.$store.dispatch('size/setWidth', window.innerWidth)
    })
  },
};
</script>


<style>
@import "@/assets/scss/only-lms/app.scss";
</style>
